import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonConstant } from 'src/app/constants/common-constant';
import { QuestionConstant } from 'src/app/constants/label-constants';

@Component({
  selector: 'app-duplicate-question-dialog-box',
  templateUrl: './duplicate-question-dialog-box.component.html',
  styleUrls: ['./duplicate-question-dialog-box.component.scss']
})
export class DuplicateQuestionDialogBoxComponent implements OnInit {
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  displayedColumns: string[] = ['QuestionSetName', 'Question', 'OptionA', 'OptionB', 'OptionC', 'OptionD', 'Answer','Reason'];
  data:any={};
  CommonConstant: any = [];
  QuestionConstant: any = [];
  NewInsertedCount:any;
  
  constructor(public modalService:NgbActiveModal,){}

  ngOnInit(): void {
    console.log(this.data);
    
    this.CommonConstant = CommonConstant;
    this.QuestionConstant = QuestionConstant;
    this.dataSource.data = this.data.duplicates;
    this.NewInsertedCount = this.data.newRecordsInserted;
  }
}
